import moment from "moment";
import React, { useContext, useMemo } from "react";
import { ScrollView } from "react-native";
import { PlayerContext } from "../../backend/PlayerContext";
import { getCreatureMessageLog } from "../../backend/exploration/Creatures";
import { Markdown } from "../utility/Markdown";

export function CreatureMessageLog() {
  const playerContext = useContext(PlayerContext);
  const messageLog = getCreatureMessageLog(playerContext);
  return useMemo(
    () => (
      <ScrollView nestedScrollEnabled={true}>
        {messageLog.map((logItem) => {
          const message =
            logItem?.realTimestamp != null
              ? `[${moment(Date.now()).format("h:mm:ss A")}] ${
                  logItem?.message ?? logItem
                }`
              : logItem?.message ?? logItem;
          return <Markdown key={logItem?.id ?? logItem}>{message}</Markdown>;
        })}
      </ScrollView>
    ),
    [messageLog.map((logItem) => logItem?.id ?? logItem).join()],
  );
}
